import * as React from 'react';

import PropTypes from 'prop-types';

import GuiDefHiddenInput from 'root/apps/Autocomplete/GuiDefHiddenInput';
import RegionAutocomplete from 'root/apps/Autocomplete/Region';
import { hasRegions } from 'root/apps/Autocomplete/Region/utils';

const AddressRegion = ({
  name,
  countryCode,
  regionName,
  regionCode,
  onChange,
  onInputChange,
  inputClassName,
  inputProps,
  hiddenInput,
  className,
  autocompleteClassName,
  ...rest
}) => (
  <>
    {hasRegions(countryCode) ? (
      <>
        <RegionAutocomplete
          countryCode={countryCode}
          regionName={regionName}
          regionCode={regionCode}
          onChange={onChange}
          inputProps={{
            ...inputProps,
            'data-validation': 'checkForCreditCardInfo',
            'data-container-selector': '.view_field_box',
          }}
          className={autocompleteClassName}
          {...rest}
        />

        <GuiDefHiddenInput name={name} value={regionName} className={className} />
      </>
    ) : (
      <input
        data-test="region-input"
        type="text"
        name={name}
        autoComplete="off"
        value={regionName}
        size="30"
        maxLength="255"
        className={className}
        onChange={(event) => onInputChange(event.target.value)}
        data-validation="checkForCreditCardInfo"
        data-container-selector=".view_field_box"
        {...rest}
        style={{ height: '32px', lineHeight: '32px' }}
      />
    )}
    <GuiDefHiddenInput name={`${name}_code`} value={regionCode} className={className} />
  </>
);

AddressRegion.defaultProps = {
  countryCode: '',
  regionName: '',
  regionCode: '',
};

AddressRegion.propTypes = {
  name: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  regionName: PropTypes.string,
  regionCode: PropTypes.string,
};

export default AddressRegion;
